import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "./index.css";
import "@/i18n"; // Phase 6a.6: initialize i18n before rendering

import App from "./App.tsx";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
